import WebGLView from './webgl/WebGLView';
import GUIView from './gui/GUIView';

export default () => {
  const webgl = new WebGLView({});

  const container = document.getElementById('particles');
  container.appendChild(webgl.renderer.domElement);

  const file = document.querySelector('.file');
  file.addEventListener('change', ({ target }) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      webgl.particles.init(e.target.result);
    };
    reader.readAsDataURL(target.files[0]);
  });

  webgl.resize();

  const gui = new GUIView({ webgl });

  const animate = () => {
    window.requestAnimationFrame(animate);

    webgl.draw();
    gui.updateAll();
  };
  animate();
};
